import { render, staticRenderFns } from "./_template-sidebar.vue?vue&type=template&id=720ea772&scoped=true&"
import script from "./_template-sidebar.vue?vue&type=script&lang=js&"
export * from "./_template-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./_template-sidebar.vue?vue&type=style&index=0&id=720ea772&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720ea772",
  null
  
)

export default component.exports